<template>
  <van-popup v-model="show" position="bottom" :close-on-click-overlay="false" class="popup_plan">
    <div class="new_plan">
      <div class="new_plan_title">{{ form.title }}</div>
      <div class="plan_item">
        <div class="_label">{{ $t('计划名称') }}</div>
        <div class="_value">
          <van-field v-model="form.title" readonly :placeholder="$t('计划名称')" />
        </div>
      </div>
      <div class="plan_item">
        <div class="_label">{{ $t('三轮投注金额') }}</div>
        <div class="_value _inputs">
          <van-field v-model="form.steps[0].money" readonly input-align="center" />
          <van-field v-model="form.steps[1].money" readonly input-align="center" />
          <van-field v-model="form.steps[2].money" readonly input-align="center" />
        </div>
      </div>
      <div class="plan_item">
        <div class="_label">{{ $t('停止跟注投注') }}</div>
        <div class="_value _radio">
          <div class="radio_item">
            <van-checkbox disabled v-model="form.stop_rules.min_profit.enabled">{{ $t('最低利润') }}</van-checkbox>
            <van-field readonly v-model="form.stop_rules.min_profit.value" input-align="center" />
            <span>USD</span>
          </div>
          <div class="radio_item">
            <van-checkbox disabled v-model="form.stop_rules.max_loss.enabled">{{ $t('损失限额') }}</van-checkbox>
            <van-field readonly v-model="form.stop_rules.max_loss.value" input-align="center" />
            <span>USD</span>
          </div>
          <div class="radio_item">
            <van-checkbox disabled v-model="form.stop_rules.max_bet_amount.enabled">{{ $t('总投注额') }}</van-checkbox>
            <van-field readonly v-model="form.stop_rules.max_bet_amount.value" input-align="center" />
            <span>USD</span>
          </div>
          <div class="radio_item">
            <van-checkbox disabled v-model="form.stop_rules.max_follow_count.enabled">{{ $t('跟注') }}</van-checkbox>
            <van-field readonly v-model="form.stop_rules.max_follow_count.value" input-align="center" />
            <span>{{ $t('时间') }}</span>
          </div>
          <div class="radio_item">
            <van-checkbox disabled v-model="form.stop_rules.max_run_hours.enabled">{{ $t('关注持续时间') }}</van-checkbox>
            <van-field readonly v-model="form.stop_rules.max_run_hours.value" input-align="center" />
            <span>{{ $t('小时') }}</span>
          </div>
          <div class="radio_item">
            <van-checkbox disabled v-model="form.status" @change="statusChange">{{ $t('立即开始') }}</van-checkbox>
          </div>
        </div>
      </div>
      <div class="btns">
        <div class="_btn" @click="cancelPop">{{ $t('My.Button.One') }}</div>
        <div class="_btn _green" @click="saveClick">{{ $t('address.btn.save') }}</div>
      </div>
    </div>
  </van-popup>
</template>
<script>
import { Popup, Toast, Field, Checkbox, CheckboxGroup } from "vant";
import { AI_PLAN_CREATE } from "@/api";
export default {
  components: {
    [Popup.name]: Popup,
    Toast,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup
  },
  props: {
    type: String,
    default: ''
  },
  data() {
    return {
      show: false,
      form: {
        title: "New plan",
        pid: 0,
        status: true,
        steps: [{
          money: '130.00'
        }, {
          money: '400.00'
        }, {
          money: '1200.00'
        }],
        stop_rules: {
          logic: "any",
          min_profit: {
            enabled: false,
            value: '0.00'
          },
          max_loss: {
            enabled: false,
            value: '0.00'
          },
          max_bet_amount: {
            enabled: false,
            value: '0.00'
          },
          max_follow_count: {
            enabled: false,
            value: 0
          },
          max_run_hours: {
            enabled: true,
            value: 24
          }
        }
      },
    }
  },
  methods: {
    open(_item = {}) {
      if (JSON.stringify(_item) != '{}') {
        this.form.title = _item?.title;
        this.form.pid = _item?.pid;
        this.form.status = _item?.status ? true : false;
        this.form.steps = _item?.content || _item?.steps;
        this.form.stop_rules = _item?.stop_rules;
        this.form.id = _item?.id;
        this.lottery_type = _item.last_lottery_type
      }
      this.show = true;
    },
    statusChange(_val) {
      if (_val) {
        this.form.status = 1;
      } else {
        this.form.status = 0;
      }
    },
    cancelPop() {
      this.show = false;
      this.clear();
    },
    async saveClick() {
      this.arCreate({ lottery_type: this.type });
    },
    async arCreate(_params = {}) {
      Toast.loading();
      try {
        const res = await AI_PLAN_CREATE({ ...this.form, status: this.form.status ? 1 : 0, ..._params });
        Toast(res.msg)
        this.cancelPop();
        setTimeout(() => {
          this.$emit('confirm')
        }, 500)
      } catch (error) {
        Toast.clear();
        error.msg && Toast(error.msg)
      }
    },
    clear() {
      this.form = {
        title: "New plan",
        pid: 0,
        status: true,
        steps: [{
          money: '130.00'
        }, {
          money: '400.00'
        }, {
          money: '1200.00'
        }],
        stop_rules: {
          logic: "any",
          min_profit: {
            enabled: false,
            value: '0.00'
          },
          max_loss: {
            enabled: false,
            value: '0.00'
          },
          max_bet_amount: {
            enabled: false,
            value: '0.00'
          },
          max_follow_count: {
            enabled: false,
            value: 0
          },
          max_run_hours: {
            enabled: true,
            value: 24
          }
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.popup_plan {
  width: 90%;
  border-radius: 20px;
  left: 50%;
  transform: translateX(-50%);

  .new_plan {
    padding: 18px;

    .new_plan_title {
      color: #111827;
      font-size: 18px;
      font-weight: 600;
      text-align: center;
    }

    .plan_item {
      margin-top: 10px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      font-weight: 600;

      ._label {
        color: #4b5563;
        font-size: 16px;
      }

      ._value {
        :deep(.van-cell) {
          border: 1px solid rgba(148, 163, 184, .32);
          border-radius: 14px;
          height: 44px;
          padding: 0 16px;
          line-height: 44px;
        }
      }

      ._inputs {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 10px;
      }

      ._radio {
        display: grid;
        gap: 14px;

        .radio_item {
          display: grid;
          align-items: center;
          gap: 10px;
          grid-template-columns: minmax(0, 1fr) 82px auto;

          :deep(.van-checkbox) {
            .van-checkbox__label {
              color: #4b5563;
              font-weight: 600;
            }

            .van-checkbox__icon--disabled .van-icon {
              background-color: transparent;
            }

            .van-checkbox__icon--checked .van-icon {
              color: #fff;
              background-color: #1989fa;
              border-color: #1989fa;
            }
          }

          span {
            color: #4b5563;
            font-size: 16px;
            font-weight: 600;
          }
        }
      }
    }

    .btns {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 18px;
      margin-top: 20px;

      ._btn {
        height: 44px;
        border-radius: 16px;
        background: var(--light);
        border: 1px solid #94a3b847;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #666;
        font-weight: 600;
      }

      ._green {
        background: linear-gradient(90deg, #8ff5d1, #31e2a5);
        border-color: transparent;
        color: #064b38;
        box-shadow: 0 9px 20px #31e2a547;
      }
    }
  }
}
</style>